// PluginContract_QuoteNode.ts
export const QuoteNodeContract = {
  pluginName: 'QuotePlugin',
  nodeTypes: ['QuoteNode'],
  register: (editor: any) => {
    editor.registerNodeType?.('QuoteNode');
    console.log('🔌 [QuotePlugin] Registered QuoteNode');
  },
};